import {Button, CountBadge, Icon, Typography} from '@sollapay/ui/components';
import {cn} from '@sollapay/ui/lib';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface HandledGroupHeaderProps {
  count: number;
  isExpanded: boolean;
  onToggle: () => void;
}

/** Divider row label for handled needs-attention instructions inside the instructions table. */
export const HandledGroupHeader: FC<HandledGroupHeaderProps> = ({count, isExpanded, onToggle}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Button
      variant="tertiary"
      size="xs"
      className="h-auto gap-2 p-0 hover:bg-transparent aria-expanded:bg-transparent"
      aria-expanded={isExpanded}
      onClick={onToggle}
    >
      <Icon
        name="chevron-down"
        width={16}
        height={16}
        className={cn('transition-transform', isExpanded && 'rotate-180')}
      />
      <Typography size="sm" weight="semibold" color="secondary">
        {t('view.instructions.handled.sectionTitle')}
      </Typography>
      <CountBadge count={count} />
      <Typography size="sm" color="tertiary">
        {t('view.instructions.handled.sectionHint')}
      </Typography>
    </Button>
  );
};
